import type { AxiosRequestConfig } from 'axios';
import api from '@seller-hermes/utils/api';
import { PAYMENT_PROVIDER_HEADER } from '../lib/provider';
import { getCurrentProvider } from '../lib/provider-store';

/**
 * Client HTTP do Repasses = o `api` do Hermes + header `x-payment-provider`
 * quando a ops escolheu um provedor no seletor (SRV-137). Sem seletor o
 * request sai igual ao de sempre (sem o header).
 */
export const withProviderHeader = (
  config?: AxiosRequestConfig,
  provider = getCurrentProvider(),
): AxiosRequestConfig => {
  if (!provider) return config ?? {};
  return {
    ...config,
    headers: {
      ...(config?.headers ?? {}),
      [PAYMENT_PROVIDER_HEADER]: provider,
    },
  };
};

export const http = {
  get: <T = any>(url: string, config?: AxiosRequestConfig) =>
    api.get<T>(url, withProviderHeader(config)),
  post: <T = any>(url: string, body?: unknown, config?: AxiosRequestConfig) =>
    api.post<T>(url, body, withProviderHeader(config)),
  patch: <T = any>(url: string, body?: unknown, config?: AxiosRequestConfig) =>
    api.patch<T>(url, body, withProviderHeader(config)),
};
